(function () {

  // async function refreshCartCount() {
  //   try {
  //     const cart = await fetch('/cart.js').then((res) => res.json());
  //     const countEl = document.querySelector('#header-cart-btn .header-cart-count');

  //     if (countEl) {
  //       countEl.textContent = cart.item_count;
  //     }
  //   } catch (e) {}
  // }

  async function refreshCartCount() {
    console.log('test');
    try {
      const cart = await fetch('/cart.js').then((res) => res.json());
      let countEl = document.querySelector('#header-cart-btn .header-cart-count');
      console.log('test');
      if (cart.item_count > 0) {
        console.log('test');
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'header-cart-count';
          const btn = document.getElementById('header-cart-btn');
          if (btn) btn.appendChild(countEl);
        }
        countEl.textContent = cart.item_count;
        countEl.classList.remove('cart-count-animate');
        void countEl.offsetWidth;
        countEl.classList.add('cart-count-animate');
      } else if (countEl) {
        countEl.remove();
      }
    } catch (e) {}
  }

  async function handleAddToCart(button, link, quantity) {
    const href = link.getAttribute('href');
    const sku = (link.getAttribute('data-sku') || '').trim().toLowerCase();
    const handle = href.split('/products/')[1]?.split('?')[0]?.split('#')[0];

    if (!handle) {
      window.location.href = href;
      return;
    }

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const product = await fetch(`/products/${handle}.js`).then((res) => res.json());

      let variant = product.variants.find(
        (v) => (v.sku || '').trim().toLowerCase() === sku
      );

      if (!variant && product.variants.length === 1) {
        variant = product.variants[0];
      }

      if (!variant) {
        window.location.href = href;
        return;
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: quantity || 1 }]
        })
      });

      button.textContent = 'Added';
      await refreshCartCount();

    } catch (error) {
      button.textContent = 'Error';
    }

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1200);
  }

  function createQtyElement() {
  const wrapper = document.createElement('div'); 
  wrapper.className = 'quantity cart-quantity';

  wrapper.innerHTML = `
    <button class="quantity__button" type="button" data-action="minus">
      <span class="svg-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2">
          <path fill="currentColor" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1"></path>
        </svg>
      </span>
    </button>

    <input
      class="quantity__input"
      type="number"
      value="1"
      min="1"
      step="1"
    >

    <button class="quantity__button" type="button" data-action="plus">
      <span class="svg-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10">
          <path fill="currentColor" d="M1 4.5a.5.5 0 0 0 0 1h3.5v3.5a.5.5 0 0 0 1 0V5.5h3.5a.5.5 0 0 0 0-1H5.5V1a.5.5 0 0 0-1 0v3.5H1z"></path>
        </svg>
      </span>
    </button>
  `;

  const input = wrapper.querySelector('.quantity__input');
  const minus = wrapper.querySelector('[data-action="minus"]');
  const plus = wrapper.querySelector('[data-action="plus"]');

  minus.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const val = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, val - 1);
  });

  plus.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const val = parseInt(input.value, 10) || 1;
    input.value = val + 1;
  });

  input.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  return { wrapper, input };
}

  function enhanceCloudSearchResults() {
    document.querySelectorAll('.see-details').forEach((block) => {
      const link = block.querySelector('a.cs-product-link');
      if (!link || block.querySelector('.xcloud-add-to-cart-btn')) return;

      const actions = document.createElement('div');
      actions.className = 'xcloud-search-actions';

      const qty = createQtyElement();

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'xcloud-add-to-cart-btn';
      button.textContent = 'Add to cart';

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const quantity = Math.max(1, parseInt(qty.input.value, 10) || 1);
        handleAddToCart(button, link, quantity);
      });

      actions.appendChild(qty.wrapper);
      actions.appendChild(button);
      block.appendChild(actions);
    });
  }

  const observer = new MutationObserver(enhanceCloudSearchResults);

  document.addEventListener('DOMContentLoaded', function () {
    enhanceCloudSearchResults();
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

})();